import React, { useEffect, useRef, useState } from 'react';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { Autocomplete } from '../components/_Autocomplete';
import { AutocompleteData } from '../models/Site';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import { useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { SimulatorModel } from '../models/SimulatorModel';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { TreatmentModel } from '../models/superbit-api-models';
import { TimePicker, TreeSelect } from 'antd';
import moment from 'moment';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import { set } from 'lodash';
import { LeadsModel } from '../models/LeadsModel';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';


type Props = {
    activeMail: string;
    to?: string;
    cc?: string;
    bcc?: string;
    subject?: string;
    body?: string;
    newEmailType?: string;
    parentMailId?: string;
    parentMessageId?: string;
    folderName?: string;
    folderType?: string;
    prevHtmlBody?: string
    attachments?: any[];
    signature?: string;
    sendMail: Function;
    openPopup?: Function;
    updateTabData?: Function;
    tabId?: string;
    customerId?: string;
    showPopUpMessage?: Function;
    ClosePopup?: Function;
};

const dic = {
    "policies": "פוליסות",
    "sues": "תביעות",
    "offers": "הצעות",
    "leads": "לידים",
} as const;

const NewEmailMessage = (props: Props) => {
    const customerModel = new CustomerCardModel();
    const simulatorModel = new SimulatorModel();
    const [treatmentsData, setTreatmentsData] = useState<TreatmentModel>(new TreatmentModel());


    const editorRef = useRef<TinyMCEEditor | null>(null);
    const ReminderDateRef = React.createRef<DatePicker>();

    const { register, getValues, setValue, handleSubmit } = useForm();
    const [emailList, setEmailList] = useState<string[]>([])
    const [emailCcList, setEmailCcList] = useState<string[]>([])
    const [emailBccList, setEmailBccList] = useState<string[]>([])
    // const [showRecipients, setShowRecipients] = useState<boolean>(true);
    const [emailAddresses, setEmailAddresses] = useState<AutocompleteData[]>([]);
    const [emailAddressesFiltered, setEmailAddressesFiltered] = useState<AutocompleteData[]>([]);
    const [recipientToAddress, setRecipientToAddress] = useState<string>('');
    const [recipientCcAddress, setRecipientCcAddress] = useState<string>('');
    const [recipientBccAddress, setRecipientBccAddress] = useState<string>('');
    const [mailAttachments, setMailAttachments] = useState<File[]>([]);
    const [sendMailStarted, setSendMailStarted] = useState<boolean>(false);
    const [initialBodyHTML, setInitialBodyHTML] = useState<string>('');
    const [mailSubject, setMailSubject] = useState<string>('');

    const [mailFrom, setMailFrom] = useState<string>('');
    const [errorTo, setErrorTo] = useState<boolean>(false);
    const [errorSubject, setErrorSubject] = useState<boolean>(false);
    const [errorSelectedHandler, setErrorSelectedHandler] = useState<boolean>(false);

    const emailSubjectDetails = useSelector((state: RootState) => state.tasks.emailSubjectDetails);
    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);

    const emailSubjectDetailsForLead = useSelector((state: RootState) => state.leads.emailSubjectDetails);

    const createTreatmentFrom = useSelector((state: RootState) => state.tasks.createTreatmentFrom);

    const [emailFromList, setEmailFromList] = useState<any[]>([]);
    const [treatmentsRelations, setTreatmentsRelations] = useState<any>({});
    const [usersList, setUsersList] = useState<any[]>([]);
    const [selectedHandler, setSelectedHandler] = useState<string>("");
    const [alertTime, setAlertTime] = useState<string>('00:00');
    const [alertDate, setAlertDate] = useState<string>('');
    const [timeFormat, setTimeFormat] = useState<string>('HH:mm');
    const [chooseRelation, setChooseRelation] = useState<string>('');
    const [treeTreatmentData, setTreeTreatmentData] = useState<any[]>([]);

    const [customersList, setCustomersList] = useState<any[]>([]);
    const [selectedCustomer, setSelectedCustomer] = useState<any | null>(null)
    const [customerId, setCustomerId] = useState<string | undefined>('');
    const [editMode, setEditMode] = useState<boolean>(false);
    const [customer, setCustomer] = useState<any | null>(null);
    const [personalDetails, setPersonalDetails] = useState<any | null>(null);
    const [editRelatedMode, setEditRelatedMode] = useState<boolean>(false);


    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        console.log(emailList)
    }, [emailList])

    const initFromTreatmentData = async () => {
        if (props.parentMessageId) {
            const treatmentData = await customerModel.treatmentGetByMessageId(props.parentMessageId);
            if (treatmentData) {
                treatmentData.id = "00000000-0000-0000-0000-000000000000";
                setEditMode(true);
                setTreatmentsData(treatmentData);
                setMailSubject(treatmentData.topic);

                setValue('mailSubject', treatmentData.topic);
                setRecipientToAddress(treatmentData.to);
                emailList.push(treatmentData.to);
                if (treatmentData.cc && treatmentData.cc.length > 0) {
                    emailCcList.push(treatmentData.cc);
                    setRecipientCcAddress(treatmentData.cc);
                }
                if (treatmentData.bcc && treatmentData.bcc.length > 0) {
                    emailBccList.push(treatmentData.bcc);
                    setRecipientBccAddress(treatmentData.bcc);
                }
                // setInitialBodyHTML(treatmentData.emailBody);
                // if (treatmentData.fileAttachments && treatmentData.fileAttachments.length > 0) {
                //     const mailAttachments: any[] = []
                //     treatmentData.fileAttachments.forEach((attachment: any) => {
                //         mailAttachments.push(convertBase64ToFile(attachment))
                //     })
                //     setMailAttachments(mailAttachments)
                // }
                const allCustomers = sessionStorage.getItem('allCustomers');
                // const allCustomers = localStorage.getItem('allCustomers');
                let allCustomersList = [];
                if (allCustomers) {
                    allCustomersList = JSON.parse(allCustomers);
                    const selectedCustomer = allCustomersList.find((a: any) => a.value == treatmentData.customerId);
                    if (selectedCustomer) {
                        setSelectedCustomer(selectedCustomer);
                        setCustomerId(treatmentData.customerId);
                    }
                }


                if (treatmentData.customerId) {
                    let relationData = await fetchRelationsData(treatmentData.customerId)
                    setRelationsData(relationData);
                }
                setChooseRelation(treatmentData.policyRelatedId ? treatmentData.policyRelatedId : treatmentData.leadRelatedId ? treatmentData.leadRelatedId :
                    treatmentData.sueRelatedId ? treatmentData.sueRelatedId : treatmentData.offerRelatedId ? treatmentData.offerRelatedId : '');

            }
        }
    }

    useEffect(() => {

        if (props.parentMessageId && props.parentMessageId != '') {
            initFromTreatmentData();
        }


    }, [props.parentMessageId && props.parentMessageId != ''])

    useEffect(() => {
        console.log('mailAttachments', mailAttachments)
        if (props.updateTabData) {
            updateTabData();
        }
    }, [mailAttachments])

    useEffect(() => {
        editorRef.current && editorRef.current.focus();
    }, [initialBodyHTML])
    // functions 

    const setRelationsData = (relationDataArg: any) => {
        const relationsData = relationDataArg;
        if (relationsData) {
            if (relationsData.leads && relationsData.leads.length > 0) {
                relationsData.leads.map((lead: any) => {
                    if (lead.offers && lead.offers.length > 0) {
                        let offers = [...lead.offers];
                        relationsData['offers'] = offers;
                    }
                })
            }
            const relationsDataKeys = Object.keys(relationsData);
            const relationsDataList: any[] = [];
            relationsDataKeys.forEach((k: string, idx: number) => {
                const relation = relationsData[k];
                const relationData: any = {
                    title: dic[k as keyof typeof dic] ? dic[k as keyof typeof dic] : k,
                    value: idx,
                    key: idx,
                    selectable: false,
                    type: k,
                }
                if (relation && relation.length > 0) {
                    const children = relation.map((c: any, i: number) => {
                        console.log('c', c)
                        return {
                            title: k == 'policies' ? c.policyNumber : k == 'sues' ? c.sueNumber ? c.sueNumber + "-" + c.internalNumber : "0-" + c.internalNumber : k == "leads" ? c.identifier : c.offerIdentity,
                            value: c.id,
                            key: c.id,
                            selectable: true,
                            type: k
                        }
                    })
                    relationData["children"] = children;
                }
                relationsDataList.push(relationData);
            })
            setTreeTreatmentData(relationsDataList);
        }
    }

    const fetchData = async (customerId: any) => {
        let obj = null;
        if (leadIdForTreatment && leadIdForTreatment.length > 0) {
            obj = { leadId: leadIdForTreatment, TreatmentType: 3 }
        } else {
            obj = { customerId: customerId, TreatmentType: 3 }
        }
        const treatmentsData = await customerModel.treatmentsForUpsert(obj);
        // set initial values of subject of the mail
        if (props.customerId) {
            if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                treatmentsData.topic = emailSubjectDetailsForLead;
            } else {
                treatmentsData.topic = emailSubjectDetails;
            }
            setValue('mailSubject', emailSubjectDetails);
            setMailSubject(emailSubjectDetails);
        } else {
            console.log('treatmentsData', treatmentsData)
            if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                treatmentsData["leadId"] = leadIdForTreatment;
            } else {
                treatmentsData["customerId"] = customerId;
            }
            // need to use this line setValue('mailSubject', emailSubjectDetails);
            treatmentsData.customer = {
                fullName: personalDetails.fullName,
                identifier: personalDetails.identifier,
            };
            setEditMode(true);
        }

        if (createTreatmentFrom && createTreatmentFrom.type && createTreatmentFrom.id) {
            if (createTreatmentFrom.type == 'policy') {
                setChooseRelation(createTreatmentFrom.id);
                treatmentsData.policyRelatedId = createTreatmentFrom.id;
                setEditRelatedMode(true);
                // let topicInfo = getRelatedInfoForSubject('policy', createTreatmentFrom.id);
                // if(topicInfo && topicInfo.length > 0){
                //     setMailSubject(topicInfo);
                //     treatmentsData.topic = topicInfo
                // }
            }
        }
        setTreatmentsData({ ...treatmentsData });

    }

    const fetchRelationsData = async (customerId: any) => {
        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${customerId}`);
        if (storedRelations) {
            const relationsDataStorage = JSON.parse(storedRelations);
            return relationsDataStorage;
        }
        const relationsData = await customerModel.treatmentsLoadRelations(customerId);
        sessionStorage.setItem(`treatmentsRelations-${customerId}`, JSON.stringify(relationsData));
        setTreatmentsRelations(relationsData);
        return relationsData;
    }

    const getRelatedInfoForSubject = (type: string, id: string) => {
        if (type == 'policy') {
            let item = treatmentsRelations['policies'] && treatmentsRelations['policies'].find((a: any) => a.id == id)
            if (item) {
                return mailSubject + `,  פוליסה מספר: ${item.policyNumber}`;
            }
        } else if (type == 'lead') {
            let item = treatmentsRelations['leads'] && treatmentsRelations['leads'].find((a: any) => a.id == id)
            if (item) {
                return mailSubject + `,  ליד מספר: ${item.identifier}`;
            }
        } else if (type == 'sue') {
            let item = treatmentsRelations['sues'] && treatmentsRelations['sues'].find((a: any) => a.id == id)
            if (item) {
                return mailSubject + `,  תביעה מספר: ${item.sueNumber}`;
            }
        }

        return '';
    }


    const init = async () => {
        console.log('props', props)
        const addresses: string | null = localStorage.getItem('emailAddresses');
        if (addresses) {
            const emailAddresses = JSON.parse(addresses).map((emailAddress: string) => {
                const retValue: any = {
                    label: emailAddress,
                    val: emailAddress,
                    value: emailAddress,
                    text: emailAddress
                };
                return retValue
            });
            console.log(emailAddresses);
            setEmailAddresses(emailAddresses)
            setEmailAddressesFiltered([]);
        }

        const emailSettingsDetails: any = localStorage.getItem('emailSettings');
        let emailSettings: any = null;
        if (emailSettingsDetails) {
            emailSettings = JSON.parse(emailSettingsDetails);
            setEmailFromList(emailSettings.emails);
            setMailFrom(emailSettings.emails.find((ea: any) => ea.main == true).emailAddress);
        }

        let allCustomersList = [];
        // const allCustomers = localStorage.getItem('allCustomers');
        const allCustomers = sessionStorage.getItem('allCustomers');
        
        if (allCustomers) {
            allCustomersList = JSON.parse(allCustomers);
        }

        if (props.customerId) {
            setCustomerId(props.customerId);
            const customer = allCustomersList.find((c: any) => c.value == props.customerId);
            setSelectedCustomer(customer);
            setEditMode(true);
        } else {
            setCustomersList(allCustomersList);
        }


        var relationData = null;
        if (props.customerId) {
            fetchData(props.customerId)
            relationData = await fetchRelationsData(props.customerId)
        }

        let handlersList: any[] = [];
        const handlersListStorage = localStorage.getItem('handlersList');
        if (handlersListStorage) {
            handlersList = JSON.parse(handlersListStorage);
            const activeHandlerList = handlersList.filter((h: any) => h.status == 0);
            setUsersList(activeHandlerList.map((u: any, i: number) => {
                return {
                    value: u.id,
                    label: u.fullName
                }
            }));
        } else {
            setUsersList([]);
        }

        setRelationsData(relationData);

        if (leadIdForTreatment && leadIdForTreatment.length > 0) {
            const lead = await new LeadsModel().getLeadForUpsert(leadIdForTreatment);
            setSelectedCustomer({
                label: lead.firstName + " " + lead.lastName,
                value: leadIdForTreatment
            })


            setPersonalDetails({
                fullName: lead.firstName + " " + lead.lastName,
                firstName: lead.firstName,
                lastName: lead.lastName,
                identifier: lead.identifier,
            });
        }


        let initialHML = '';
        if (props.to) {
            const emails = props.to.split(',');
            const toEmails: string[] = []
            emails.forEach((email: string) => {
                toEmails.push(email);
            })
            setEmailList(toEmails);
        }
        if (props.cc) {
            const emails = props.cc.split(',');
            const ccEmails: string[] = []
            emails.forEach((email: string) => {
                ccEmails.push(email);
            })
            setEmailCcList(ccEmails);
        }
        if (props.attachments) {
            const mailAttachments: any[] = []
            props.attachments.forEach((attachment: any) => {
                mailAttachments.push(convertBase64ToFile(attachment))
            })
            setMailAttachments(mailAttachments)
        }

        if (props.body) {
            initialHML += props.body;
        } else {
            initialHML += '<p style="direction: rtl;"></p>';
        }
        let signature = localStorage.getItem('userSignature')
        if (props.signature) {
            signature = props.signature
        }
        initialHML += '<div style="padding-top:100px; direction: rtl;">' + signature + '</div>';
        if (props.prevHtmlBody) {
            initialHML += props.prevHtmlBody;
        }
        setInitialBodyHTML(initialHML)
        if (props.subject) {
            setMailSubject(props.subject);
            setValue('mailSubject', props.subject);
        }
        console.log('EmailContentShow', props);

    }

    const convertBase64ToFile = (attachment: any) => {
        if (!attachment.content) {
            return attachment;
        }
        const attachmentContent = attachment.content.split('base64,');
        console.log('convertBase64ToFile', attachment, attachmentContent)
        const binaryString = window.atob(attachmentContent[1]);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/octet-stream' });
        const file = new File([blob], attachment.name, { type: 'application/octet-stream' });
        return file;
    }

    const onSelectEmailAddress = (name: string, value: any) => {
        console.log(name, value)
    }

    const onRecipientChange = (e: any, target: string = 'to') => {
        const newValue = e.target.value;
        console.log('onRecipientChange', newValue);
        switch (target) {
            case 'to':
                setRecipientToAddress(newValue);
                break;
            case 'cc':
                setRecipientCcAddress(newValue);
                break;
            case 'bcc':
                setRecipientBccAddress(newValue);
                break;
            default:
                break;
        }
        const selectedAddress = emailAddresses.find(x => x.label == newValue);
        if (selectedAddress) {
            const data = treatmentsData as TreatmentModel;
            switch (target) {
                case 'to':
                    emailList.push(newValue);
                    setRecipientToAddress('');
                    if (data && data.to && data.to.length > 0) {
                        data.to += ';' + newValue;
                    } else {
                        data.to = newValue;
                    }
                    break;
                case 'cc':
                    emailCcList.push(newValue);
                    setRecipientCcAddress('');
                    if (data["cc"] && data["cc"].length > 0) {
                        data["cc"] += ';' + newValue;
                    } else {
                        data["cc"] = newValue;
                    }
                    break;
                case 'bcc':
                    emailBccList.push(newValue);
                    setRecipientBccAddress('');
                    if (data["bcc"] && data["bcc"].length > 0) {
                        data["bcc"] += ';' + newValue;
                    } else {
                        data["bcc"] = newValue;
                    }
                    break;
                default:
                    break;
            }
            setTreatmentsData(data);
        }
        if (newValue && newValue.length > 0) {
            const addresses = emailAddresses.filter(x => x.label != null && x.label.indexOf(newValue) > -1);
            setEmailAddressesFiltered(addresses);
        } else {
            setEmailAddressesFiltered(emailAddresses);
        }
        updateTabData();
    }

    const validateEmail = (email: string) => {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    }

    const checkRecipientEmail = (e: any, target: string = 'to') => {
        if (!e || !e.target) {
            return;
        }
        const text = e.target.value;
        console.log('checkRecipientEmail', text);
        if (text == '') {
            return;
        }
        if (validateEmail(text)) {
            switch (target) {
                case 'to':
                    emailList.push(text);
                    setRecipientToAddress('');
                    break;
                case 'cc':
                    emailCcList.push(text);
                    setRecipientCcAddress('');
                    break;
                case 'bcc':
                    emailBccList.push(text);
                    setRecipientBccAddress('');
                    break;
                default:
                    break;
            }
        } else {
            openPopup('שגיאה', `כתובת אימייל - ${text} לא תקינה`);
        }
    }

    const onRecipientSelect = (recipient: string, target: string = 'to') => {
        console.log('onRecipientSelect', recipient);
        switch (target) {
            case 'to':
                const toEmails = [...emailList]
                toEmails.push(recipient);
                setEmailList(toEmails);
                setRecipientToAddress('');
                break;
            case 'cc':
                const ccEmails = [...emailCcList]
                ccEmails.push(recipient);
                setEmailCcList(ccEmails);
                setRecipientCcAddress('');
                break;
            case 'bcc':
                const bccEmails = [...emailBccList]
                bccEmails.push(recipient);
                setEmailBccList(bccEmails);
                setRecipientBccAddress('');
                break;
            default:
                break;
        }

        setEmailAddressesFiltered(emailAddresses);

        console.log('emailList', emailList, 'emailCcList', emailCcList, 'emailBccList', emailBccList)

    }

    const onSubjectSubject = (e: any) => {
        // console.log('onSubjectSubject', e);
        const data = treatmentsData as TreatmentModel;
        const newSubject = e.target.value;
        if (newSubject.length > 0) {
            setErrorSubject(false);
        }
        if (data.topic) {
            data.topic = newSubject;
            setTreatmentsData(data);
        }
        setValue('mailSubject', newSubject);
        setMailSubject(newSubject);
        updateTabData();
    }

    const onEditorChange = () => {
        updateTabData();
    }

    const onRemoveRecipient = (emailAddress: string, target: string = 'to') => {
        let emails: string[] = [];
        switch (target) {
            case 'to':
                emails = emailList.filter((email: string) => email !== emailAddress);
                setEmailList(emails);
                break;
            case 'cc':
                emails = emailCcList.filter((email: string) => email !== emailAddress);
                setEmailCcList(emails);
                break;
            case 'bcc':
                emails = emailBccList.filter((email: string) => email !== emailAddress);
                setEmailBccList(emails);
                break;
            default:
                break;
        }
    }

    const onDeleteAttachment = async (index: number, attachment: any) => {
        const attachments = [...mailAttachments];
        delete attachments[index];
        await setMailAttachments(attachments);
        updateTabData();
    }


    const handleUploadedFile = async (event: any) => {
        const files = event.target.files;
        console.log(files)

        const attachments = [...mailAttachments];
        for (let i = 0; i < files.length; i++) {
            attachments.push(files[i]);
        }
        await setMailAttachments(attachments);
        console.log('setMailAttachments', attachments)
        // event.target.value = null;
        // updateTabData();
        const fileUploaded = event.target.files[0];
        console.log('fileUploaded', fileUploaded)
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                const data = treatmentsData as TreatmentModel;
                const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                if (!data.fileAttachments) {
                    data.fileAttachments = [];
                }
                data.fileAttachments.push(
                    {
                        FileName: fileName,
                        Content: reader.result
                    }
                );

                setTreatmentsData(data);
            }
            reader.readAsDataURL(fileUploaded);
        }
    };

    const onNewEmailSubmit = async (data: any) => {
        const treatmentData = treatmentsData as TreatmentModel;
        if (sendMailStarted) return;

        console.log('1111111111111111', treatmentData)
        setSendMailStarted(true);
        const formData = new FormData();
        if (mailAttachments && mailAttachments.length > 0) {
            mailAttachments.map((file) => {
                formData.append(`Attachments`, file);
            })
        }
        formData.append(`From`, mailFrom);
        treatmentData.from = mailFrom;

        let recipentsTo = '';
        emailList.forEach((email: string) => {
            if (recipentsTo != '') {
                recipentsTo += ',';
            }
            recipentsTo += email;
        })
        formData.append("To", recipentsTo);
        treatmentData.to = recipentsTo;

        if (emailCcList && emailCcList.length > 0) {
            let recipentsCc = '';
            emailCcList.forEach((email: string) => {
                if (recipentsCc != '') {
                    recipentsCc += ',';
                }
                recipentsCc += email;
            });
            formData.append("Cc", recipentsCc);
            treatmentData.cc = recipentsCc;
        }

        if (emailBccList && emailBccList.length > 0) {
            let recipentsBcc = '';
            emailBccList.forEach((email: string) => {
                if (recipentsBcc != '') {
                    recipentsBcc += ',';
                }
                recipentsBcc += email;
            });
            formData.append("Bcc", recipentsBcc);
            treatmentData.bcc = recipentsBcc;
        }
        if (editorRef.current) {
            formData.append("Body", editorRef.current.getContent());
            treatmentData.emailBody = editorRef.current.getContent();
            // console.log(editorRef.current.getContent());
        }

        formData.append("Subject", data.mailSubject);
        // formData.append("Body", data.mailContent);
        formData.append("ActiveMail", props.activeMail);
        formData.append("SendMailType", '0');
        if (props.folderName) {
            formData.append('folderName', props.folderName);
        }
        if (props.folderType) {
            formData.append("Folder", props.folderType);
        }

        if (props.newEmailType) {
            if (props.newEmailType == 'reply') {
                if (props.parentMailId) {
                    formData.append('ReplyToId', props.parentMailId);
                } else if (props.parentMessageId) {
                    formData.append('ReplyToMessageId', props.parentMessageId);
                }
            }
            if (props.newEmailType == 'forward') {
                if (props.parentMailId) {
                    formData.append('ForwardId', props.parentMailId);
                } else if (props.parentMessageId) {
                    formData.append('ForwardMessageId', props.parentMessageId);
                }
            }
        }
        if (customerId && customerId.length > 0) {
            if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                // treatmentData["leadsIds"] = leadIdForTreatment;
            } else {
                treatmentData.customerId = customerId;
            }
            treatmentData.customer = customer;
            treatmentData.topic = data.mailSubject;
        }
        setTreatmentsData(treatmentData);

        let valid = true;

        if (treatmentData.alertDate && (treatmentData.belongsToId === null || treatmentData.belongsToId === '' || treatmentData.belongsToId === undefined)) {
            setErrorSelectedHandler(true);
            valid = false;
        }
        if (data.mailSubject == "" && (treatmentData.topic == '' || treatmentData.topic == undefined)) {
            setErrorSubject(true);
            valid = false;
        }
        if (!recipentsTo || recipentsTo.length == 0) {
            setErrorTo(true);
            valid = false;
        }

        if (recipentsTo && recipentsTo.length > 0 && data.mailSubject && data.mailSubject !== '') {
            let res = await props.sendMail(formData, props.tabId);
            console.log('res', res)
            if (customerId && customerId.length > 0 || (leadIdForTreatment && leadIdForTreatment.length > 0)) {
                saveTreatment(res);
                // closePopup();
            }
        } else {
            if (data.mailSubject == '') {
                openPopup('שגיאה', 'חסר נושא, נא למלא');
            }
            if (!recipentsTo || recipentsTo.length == 0) {
                openPopup('שגיאה', 'חסר נמען, נא למלא');
            }
        }
        setSendMailStarted(false);
    }

    const saveTreatment = async (result: any) => {
        console.log('saveTreatment argument', result)
        if (treatmentsData) {
            if (treatmentsData.alertDate == null || treatmentsData.alertDate == undefined) {
                treatmentsData.seen = true;
            }
            if (result.code) {
                treatmentsData.messageId = result.code;
            }
            const res = await customerModel.treatmentsUpsertTreatment(treatmentsData);
            console.log('treatmentsUpsertTreatment', res)
            if (res && (res.label === "טיפול שוטף נוצר בהצלחה!" || res.label === "טיפול שוטף עודכן בהצלחה!")) {

                console.log('saveTreatment', res);
                if (props.showPopUpMessage) {
                    props.showPopUpMessage('המייל נשלח, וטיפול שוטף מסוג דוא"ל נוצר בהצלחה');
                }
                closePopup();


            }
        } else {
            console.log('saveTreatment', 'no data');
        }

    }

    const openPopup = (title: string, text: string) => {
        if (props.openPopup) {
            props.openPopup(
                {
                    title,
                    description: text
                }
            )
        }
    }

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup();
        }
    }

    const updateTabData = () => {
        if (props.updateTabData) {
            let htmlBody = '';
            if (editorRef.current) {
                htmlBody = editorRef.current.getContent();
            }
            let recipentsTo = '';
            let recipentsCc = '';
            let recipentsBcc = '';
            emailList.forEach((email: string) => {
                if (recipentsTo != '') {
                    recipentsTo += ',';
                }
                recipentsTo += email;
            })

            if (emailCcList && emailCcList.length > 0) {
                emailCcList.forEach((email: string) => {
                    if (recipentsCc != '') {
                        recipentsCc += ',';
                    }
                    recipentsCc += email;
                });
            }

            if (emailBccList && emailBccList.length > 0) {
                emailBccList.forEach((email: string) => {
                    if (recipentsBcc != '') {
                        recipentsBcc += ',';
                    }
                    recipentsBcc += email;
                });
            }
            props.updateTabData(props.tabId, {
                body: htmlBody,
                to: recipentsTo,
                cc: recipentsCc,
                bcc: recipentsBcc,
                title: mailSubject,
                attachments: mailAttachments
            })
        }
    }

    const onChangeFrom = (e: any) => {
        console.log('onChangeFrom', e.target.value);
        setMailFrom(e.target.value);
    }

    const onSelectBelongsTo = (e: any) => {
        const userName = e.target.value;
        console.log('userName', userName)
        const selected = usersList.find((a: any) => a.label == userName);
        console.log('selected', selected)
        let selectHandler = userName;
        // selectHandler = userName;
        setSelectedHandler(selectHandler)
        if (selected) {
            setErrorSelectedHandler(false);
            const data = treatmentsData as TreatmentModel;
            data.belongsToId = selected.value;
            setTreatmentsData(data);
            // const errors = validationErrors;
            // errors.selectedHandler = false;
            // setValidationErrors(errors);
        } else {
            // setSelectedHandler("")
            const data = treatmentsData as TreatmentModel;
            data.belongsToId = undefined;
            setTreatmentsData(data);
        }
    }

    const onAlertTimeChange: any = (time: any, timeString: string) => {
        console.log(time, timeString);
        setAlertTime(timeString);
        const data = treatmentsData as TreatmentModel;
        if (data.alertDate) {
            let newDateString = moment(data.alertDate).format('YYYY-MM-DD');
            newDateString += " " + timeString;
            console.log('newDateString', newDateString)
            data.alertDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
            console.log('DateChange', data.alertDate)
            setTreatmentsData(data);
        }
    };

    const onAlertDateChange = (newDate: any) => {
        console.log('onAlertDateChange', newDate);
        const data = treatmentsData as TreatmentModel;
        let newDateString = moment(newDate).format('YYYY-MM-DD');
        newDateString += " " + alertTime;
        if (moment(newDateString).isValid()) {
            data.alertDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm')); //newDate
            setAlertDate(moment(newDateString).format('YYYY-MM-DD'));

            setTreatmentsData(data);
        } else {
            data.alertDate = undefined;
            setTreatmentsData(data);
        }
        if (newDate == null || newDate == undefined) {
            data.alertDate = undefined;
            setAlertDate('');
            setAlertTime('00:00');
            setTreatmentsData(data);
        }
        console.log('DateChange', data.alertDate)
    }

    // const onClear = () => {
    //     const data = treatmentsData as TreatmentModel;
    //     if (data.policyRelatedId) {
    //         data.policyRelatedId = undefined;
    //     }
    //     if (data.leadRelatedId) {
    //         data.leadRelatedId = undefined;
    //     }
    //     if (data.sueRelatedId) {
    //         data.sueRelatedId = undefined;
    //     }
    //     if (data.offerRelatedId) {
    //         data.offerRelatedId = undefined;
    //     }
    //     setChooseRelation('');
    //     setTreatmentsData(data);
    // }

    const onChangeRelations = (v: any) => {
        console.log('onChangeRelations', v);
        const data = treatmentsData as TreatmentModel;
        let selectedItem = null;
        // need to check whiche branch in tree data treeTreatmentData  is selected if is policies or leads or sues
        for (let i = 0; i < treeTreatmentData.length; i++) {
            let Item = treeTreatmentData[i].children && treeTreatmentData[i].children.length > 0 && treeTreatmentData[i].children.find((a: any) => a.key == v);
            if (Item) {
                console.log('Item', Item)
                selectedItem = Item;
            }
        }
        // const selected = selectedData.find((a: any) => a.children.find((c: any) => c.key == v));
        // let selected = treeTreatmentData.find((a: any) => a.children && a.children.length > 0);
        // console.log('filterdList', selected)
        // let item = selected.children.find((a: any) => a.key == v);

        let newSubjectText = '';
        console.log('selectedItem.type', selectedItem.type)

        if (selectedItem) {
            switch (selectedItem.type) {
                case 'policies':
                    data["policyRelatedId"] = v;
                    newSubjectText = `,  פוליסה מספר: ${selectedItem.title}`;
                    break;
                case 'leads':
                    data["leadRelatedId"] = v;
                    newSubjectText = `,  ליד מספר: ${selectedItem.title}`;
                    break;
                case 'offers':
                    data["offerRelatedId"] = v;
                    newSubjectText = `,  הצעה מספר: ${selectedItem.title}`;
                    break;
                case 'sues':
                    data["sueRelatedId"] = v;
                    newSubjectText = `,  תביעה מספר: ${selectedItem.title}`;
                    break;
                default:

            }
        }
        console.log('newSubjectText', newSubjectText)
        data.topic = data.topic + newSubjectText;
        setMailSubject(mailSubject + newSubjectText);
        setValue('mailSubject', mailSubject + newSubjectText);


        console.log('data', data)
        setChooseRelation(v);
        setTreatmentsData(data);
        setErrorSubject(false);
        // updateTabData();
    }

    const onChangeComment = (e: any) => {
        const data = treatmentsData as TreatmentModel;
        data["note"] = e.target.value;
        setTreatmentsData(data);
    }

    const setCustomerRef = async (customerId: string) => {
        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${customerId}`);
        if (storedRelations) {
            const relationsDataStorage = JSON.parse(storedRelations);
            setTreatmentsRelations(relationsDataStorage);
            setRelationsData(relationsDataStorage);
            return;
        }
        const relationsData = await customerModel.treatmentsLoadRelations(customerId);
        sessionStorage.setItem(`treatmentsRelations-${customerId}`, JSON.stringify(relationsData));
        setTreatmentsRelations(relationsData);
        if (relationsData) {
            setRelationsData(relationsData);
        }
    }

    const onSelectCustomer = async (e: any) => {
        console.log('onSelectCustomer', e.target.value);
        const customerName = e.target.value;
        const selected = customersList.find((a: any) => a.label == customerName);
        if (selected) {
            setSelectedCustomer(selected);
            setCustomerId(selected.value);
            const customer = await customerModel.getCustomerCardDetails(selected.value);
            if (customer) {
                let customerDetails = customer.personalData.customerData;
                setCustomer(customerDetails);
                let personalDetails = `שם: ${customerDetails.fullName}, ת"ז: ${customerDetails.identifier}`
                setValue('mailSubject', personalDetails);
                setMailSubject(personalDetails);
            }
            await fetchData(selected.customerId)
            setCustomerRef(selected.value);
        } else {
            setSelectedCustomer(null)
        }
    }

    return (
        <>
            <div className="email-content">
                <form method='post' onSubmit={handleSubmit(onNewEmailSubmit)}>
                    <div className="email-form-row">
                        <div className="label">
                            מאת
                        </div>
                        <div className="recipients-row">
                            <select value={mailFrom} onChange={(e: any) => onChangeFrom(e)} style={{ width: '228px' }}>
                                {emailFromList.map((email: any, i: number) => {
                                    return (
                                        <option key={i} value={email.emailAddress}>{email.emailAddress}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="email-form-row">
                        <div className="label">
                            אל
                        </div>
                        <div className="recipients-row">
                            {emailList.map((recipient: string, i: number) => {
                                if (recipient) {
                                    return (
                                        <div className="recipient-tag" key={i}>
                                            {recipient}
                                            <div className="close">
                                                <div className="icon x-close-grey" onClick={() => onRemoveRecipient(recipient, 'to')}></div>
                                            </div>
                                        </div>
                                    )
                                }
                            }
                            )}

                            <div className="field">
                                <div className="value">
                                    <input type='text'
                                        list="email_list1"
                                        value={recipientToAddress}
                                        onChange={(e: any) => onRecipientChange(e, 'to')}
                                        onBlur={(e: any) => checkRecipientEmail(e, 'to')}
                                    />
                                    <datalist id="email_list1">
                                        {emailAddressesFiltered.map((o, i) => <option key={i} value={o.val}>{o.val}</option>)}
                                    </datalist>
                                </div>
                            </div>
                        </div>
                    </div>
                    {errorTo ? <div style={{ color: 'red' }}>
                        שדה חובה</div> : <></>}
                    <div className="email-form-row">
                        <div className="label">
                            CC
                        </div>
                        <div className="recipients-row">
                            {emailCcList.map((recipient: string, i: number) => {
                                if (recipient) {
                                    return (
                                        <div className="recipient-tag" key={i}>
                                            {recipient}
                                            <div className="close">
                                                <div className="icon x-close-grey" onClick={() => onRemoveRecipient(recipient, 'cc')}></div>
                                            </div>
                                        </div>
                                    )
                                }
                            }
                            )}
                            <div className="field">
                                <div className="value">
                                    <input type='text'
                                        list="email_list2"
                                        value={recipientCcAddress}
                                        onChange={(e: any) => onRecipientChange(e, 'cc')}
                                        onBlur={(e: any) => checkRecipientEmail(e, 'cc')}
                                    />
                                    <datalist id="email_list2">
                                        {emailAddressesFiltered.map((o, i) => <option key={i} value={o.val}>{o.val}</option>)}
                                    </datalist>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="email-form-row">
                        <div className="label">
                            BCC
                        </div>
                        <div className="recipients-row">
                            {emailBccList.map((recipient: string, i: number) => {
                                if (recipient) {
                                    return (
                                        <div className="recipient-tag" key={i}>
                                            {recipient}
                                            <div className="close">
                                                <div className="icon x-close-grey" onClick={() => onRemoveRecipient(recipient, 'bcc')}></div>
                                            </div>
                                        </div>
                                    )
                                }
                            }
                            )}
                            <div className="field">
                                <div className="value">
                                    <input type='text'
                                        list="email_list3"
                                        value={recipientBccAddress}
                                        onChange={(e: any) => onRecipientChange(e, 'bcc')}
                                        onBlur={(e: any) => checkRecipientEmail(e, 'bcc')}
                                    />
                                    <datalist id="email_list3">
                                        {emailAddressesFiltered.map((o, i) => <option key={i} value={o.val}>{o.val}</option>)}
                                    </datalist>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="email-form-row subject-row">
                        <div className="label">
                            נושא
                        </div>
                        <div className="field">
                            <div className="value">
                                <input type="text" {...register("mailSubject")} value={mailSubject} onChange={onSubjectSubject}
                                    disabled={props.parentMessageId && props.parentMessageId != '' ? true : false} />
                            </div>
                        </div>
                    </div>
                    {errorSubject ? <div style={{ color: 'red' }}>
                        שדה חובה
                    </div> : <></>}

                    <div className="parameter-row">
                        <div className={`parameter-item`} style={{ width: '22%' }}>
                            <div className="field">
                                <div className="title">
                                    תיק לקוח:
                                </div>
                                <div className="value">
                                    <input type='text'
                                        list="customer_list"
                                        placeholder='בחר תיק'
                                        disabled={!customersList || editMode}
                                        onChange={(e: any) => onSelectCustomer(e)}
                                        value={selectedCustomer && selectedCustomer.label}
                                    />
                                    <datalist id="customer_list">
                                        {customersList && customersList.map((a: any, i: number) => <option key={i} value={a.label}>{a.label}</option>)}
                                    </datalist>
                                </div>
                                <div className='error-message'>
                                    {/* *{this.state.errors.requiredField} */}
                                </div>
                            </div>
                        </div>
                        <div className={`parameter-item`} style={{ width: '22%' }}>
                            <div className="field">
                                <div className="title">
                                    לטיפול ע"י:
                                </div>
                                <div className="value">
                                    <input type='text'
                                        list="handler_list"
                                        placeholder='בחר מטפל'
                                        onChange={(e: any) => onSelectBelongsTo(e)}
                                        value={selectedHandler}
                                    // disabled={props.parentMessageId && props.parentMessageId != '' ? true : false}
                                    />
                                    <datalist id="handler_list">
                                        {usersList && usersList.map((u: any, i: number) => <option key={i} value={u.label}>{u.label}</option>)}
                                    </datalist>

                                </div>
                                {errorSelectedHandler ? <div style={{ color: 'red' }}>
                                    שדה חובה
                                </div> : <></>}
                            </div>
                        </div>


                        <div className={`parameter-item`} style={{ width: '30%' }}>
                            <div className="field">
                                <div className="title">
                                    ת. תזכורת
                                </div>
                                <div className="value">
                                    <TimePicker
                                        variant="borderless"
                                        onChange={onAlertTimeChange}
                                        defaultValue={dayjs('00:00', timeFormat)}
                                        value={dayjs(alertTime, timeFormat)}
                                        format={timeFormat}
                                        popupClassName='time-picker-time-list'
                                        allowClear={false}
                                    // disabled={props.parentMessageId && props.parentMessageId != '' ? true : false}

                                    />

                                    <CompDatePicker
                                        value={alertDate ? new Date(alertDate) : undefined}
                                        onChange={(e: any) => onAlertDateChange(e)}
                                    />

                                    {/* <DatePicker
                                        ref={ReminderDateRef}
                                        selected={alertDate ? new Date(alertDate) : undefined}
                                        onChange={onAlertDateChange}
                                        dateFormat='dd/MM/yyyy'
                                    // disabled={props.parentMessageId && props.parentMessageId != '' ? true : false}
                                    /> */}
                                </div>
                            </div>
                        </div>
                        <div className={`parameter-item`} style={{ width: '26%' }}>
                            <div className="field">
                                <div className="title">
                                    שייך ל
                                </div>
                                <div className="value">
                                    <TreeSelect
                                        treeLine
                                        placeholder='שייך ל'
                                        showSearch
                                        style={{
                                            width: '100%',
                                        }}
                                        dropdownStyle={{
                                            maxHeight: 400,
                                            overflow: 'auto',
                                        }}
                                        allowClear
                                        onChange={(v: any) => onChangeRelations(v)}
                                        treeData={treeTreatmentData}
                                        value={chooseRelation}
                                        disabled={(props.parentMessageId && props.parentMessageId != '') || editRelatedMode ? true : false}

                                    // disabled={this.isRefDisabled()}
                                    />

                                </div>
                                <div className='error-message'>
                                    שדה חובה
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="parameter-row single-item">
                        <div className={`parameter-item`}>
                            <div className="field">
                                <div className="value">
                                    הערות:
                                    <input type='text' value={treatmentsData && treatmentsData.note} onChange={onChangeComment} />
                                </div>
                                <div className='error-message'>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <Editor
                            onInit={(evt, editor) => editorRef.current = editor}
                            apiKey='djtel3sjck5h6t7794w5lrm3q570rvj1rxr48es3xq7ft83w'
                            initialValue={initialBodyHTML}
                            init={{
                                height: 250,
                                menubar: false,
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                ],
                                language: "he_IL",
                                toolbar: 'undo redo | blocks | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                            }}
                            onChange={onEditorChange}
                        />
                    </div>
                    <div className='attachment-row'>
                        {mailAttachments.map((mAttachment: any, i: number) => {
                            if (mAttachment) {
                                return (
                                    <div className="recipient-tag" key={i}>
                                        <div>
                                            {mAttachment.name}
                                        </div>
                                        <div>
                                            <div className="icon trash-brown pointer" onClick={() => { onDeleteAttachment(i, mAttachment) }}></div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                        )}
                    </div>
                    <div >
                        <div className="action-cell" style={{ display: 'block' }}>
                            <input type="file" multiple {...register("file")} onChange={handleUploadedFile} style={{ marginBottom: 20 }} />
                            {!sendMailStarted ? (<button type="submit" id="btn-new-email" disabled={sendMailStarted} className="new-email button blue flex-centered flex-justify-center">
                                שמור ושלח
                            </button>) : (
                                <></>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default NewEmailMessage